<template>
  <component :is="tag" class="list" :class="modifiers">
    <component
      :is="childTag"
      v-for="(item, index) in items"
      :key="`item_${index}`"
      :data-animation="animation"
      :data-animation-delay="animation ? (delay + index * itemDelay) : false"
      class="list__item"
      v-html="item.text"
    >
      <slot name="item" v-bind="item" />
    </component>
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BaseList',
  props: {
    tag: {
      type: String,
      default: 'ul',
    },
    items: {
      type: Array,
      default: () => [],
    },
    animation: {
      type: String,
      default: 'fadeInBottom',
    },
    delay: {
      type: Number,
      default: 0,
    },
    itemDelay: {
      type: Number,
      default: 150,
    },
    size: {
      type: String,
      default: '',
    },
    isBold: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    childTag() {
      if (this.tag === 'ul' || this.tag === 'ol') return 'li';
      return 'div';
    },
    modifiers() {
      const modifiers = {
        list_bold: this.isBold,
        [`list_size_${this.size}`]: this.size,
      };
      return modifiers;
    },
  },
};
</script>

<style lang="stylus">
.list
  display block
  list-style none
  padding 0
  margin 0

  &_bold
    font-weight 700

  &_size_xxs
    font-size 0.7em

  &_size_xs
    font-size 0.8em

  &_size_s
    font-size 0.9em

  &_size_m
    font-size 1.1em

  &_size_l
    font-size 1.2em

  &_size_xl
    font-size 1.3em

  &_size_xxl
    font-size 1.4em

  &__item
    font-size 1em
    line-height typeof( $f_height ) == 'unit' ? $f_height : 1.6
    padding 0 0 0 1.5em
    margin-top 0.7em
    +landscape()
      margin-top 0.5em

    &:before
      content '\25CF'
      font-family Arial
      display block
      float left
      color #22215B
      margin-left -1.4em

    &:first-child
      margin-top 0
      margin-left 0
</style>
